<template>
    <form
        :class="classes"
        @submit.prevent="submit">
        <div class="form__field form__field--label-headline">
            <label
                class="password-label"
                for="password">
                {{ $t("Login form") }}
                <p>
                    {{ $t("Thank you. We have just sent you an e-mail.")
                    }}<br />
                    {{
                        $t(
                            "Click on the link you have received or enter the registration code below."
                        )
                    }}
                </p>
            </label>
            <input
                id="email"
                v-model="form.email"
                type="hidden"
                name="email" />
            <TextInput
                id="password"
                v-model="form.password"
                type="text"
                :placeholder="$t('Registration code')"
                :error="errors.password"
                :force-error="forceErrors" />
        </div>
        <button
            class="form__submit"
            @submit.prevent="submit">
            {{ $t("Login") }}
        </button>
        <div class="form__footer resend-login">
            <span>{{ $t("Not receiving the e-mail?") }}</span>
            <button
                type="button"
                class="button button--text resend-login__link"
                @click.prevent="resendLogin">
                {{ $t("Click here.") }}
            </button>
        </div>
    </form>
</template>

<script>
    import FormMixin from "./FormMixin";

    export default {
        name: "FormPassword",
        mixins: [FormMixin],
        data: function () {
            return {
                form: {
                    email: "",
                    password: ""
                },
                errors: {
                    password: ""
                }
            };
        },
        watch: {
            "form.password"() {
                this.validate();
                if (this.form.password.length === 5) {
                    this.submit();
                }
            }
        },
        async mounted() {
            this.validate();
            const email =
                this.$route.query.email ||
                this.$store.state.auth.user.email ||
                "";

            if (!email) return this.$router.push({ name: "login" });

            this.form.email = email.replace(" ", "+");

            // when opening the link in the email, the query will be set
            const otp = this.$route.query.otp;

            // if email and otp are already set, try to login
            if (email && email.length > 0 && otp && otp.length === 5) {
                await this.ensureUser();
                this.form.password = otp;
            }
        },
        methods: {
            submit() {
                if (!this.valid) return (this.forceErrors = true);
                const successMessage = this.$t(
                    "Welcome! Your login was successful."
                );
                const errorMessage = this.$t(
                    "Something went wrong, please check your information and try again later."
                );

                this.$store
                    .dispatch("auth/auth", {
                        ...this.form,
                        successMessage,
                        errorMessage
                    })
                    .then(() => this.$router.push({ name: "dashboard" }))
                    .catch(() => this.$store.commit("auth/setLoading", false));
            },
            resendLogin() {
                const successMessage = this.$t(
                    "We sent the e-mail again, you should receive an e-mail with your registration code."
                );
                const errorMessage = this.$t(
                    "Something went wrong, please check your information and try again later."
                );
                this.$store
                    .dispatch("auth/login", {
                        email: this.form.email,
                        successMessage,
                        errorMessage,
                        sendEmail: true
                    })
                    .finally(() =>
                        this.$store.commit("auth/setLoading", false)
                    );
            },
            async ensureUser() {
                const email = this.form.email;
                const user = this.$store.state.auth.user.id;
                if (!email || !!user) return;

                await this.$store.dispatch("auth/login", {
                    email,
                    successMessage: null,
                    errorMessage: null,
                    sendEmail: false
                });
            },
            validate() {
                if (!this.form.password)
                    this.setError(
                        "password",
                        this.$t("This field is required")
                    );
                else this.deleteError("password");
            }
        }
    };
</script>
<style scoped lang="scss">
    @import "~@/styles/variables";

    .resend-login {
        display: flex;
        flex-direction: column;

        &__link {
            padding: 0.5rem 0 0.25rem 0;
        }
    }
</style>
